import { getServiceComponent } from '@/utils'

import componentNotFound from '@/components/misc/componentNotFound'

export function page(name) {
  return {
    name,

    metaInfo: {
      title: `${name.split('/').join('.')}.title`
    },

    render(h) {
      try {
        return h(getServiceComponent(`${name}/template`))
      } catch (error) {
        return h(componentNotFound)
      }
    }
  }
}
